<ng-container *transloco="let t">
  <a class="link-unstyled" mat-button [matMenuTriggerFor]="languageMenu">
    <mat-icon class="mr-1">language</mat-icon>
    <span>{{ (translateService.langChanges$ | async)?.toUpperCase() }}</span>
    <mat-icon>arrow_drop_down</mat-icon>
  </a>
  <mat-menu #languageMenu="matMenu">
    <a mat-menu-item (click)="changeLanguage('en')">
      <span>{{ t('languages.english') }}</span>
    </a>
    <a mat-menu-item (click)="changeLanguage('de')">
      <span>{{ t('languages.german') }}</span>
    </a>
  </mat-menu>
</ng-container>
